/**
 * Amie Quiz Engine v2.0
 * Supports: standard multiple-choice, agree-scale, interstitials, clinical results.
 * Backward compatible with v1 quizzes (standard question format unchanged).
 */
(function () {
  'use strict';

  window.AmieQuiz = {
    currentStep: 0,
    answers: {},
    scores: {},
    totalSteps: 0,
    questionCount: 0,
    currentQuestionNum: 0,
    quizName: '',
    container: null,
    questions: [],
    results: [],
    utm: {},
    agreeScaleValues: [],
    clinicalMode: false,

    init: function (config) {
      this.quizName = config.name || 'quiz';
      this.container = document.getElementById('amie-quiz');
      if (!this.container) return;
      this.questions = config.questions || [];
      this.results = config.results || [];
      this.clinicalMode = config.clinical || false;
      this.totalSteps = this.questions.length;
      this.questionCount = this.questions.filter(function (q) { return q.type !== 'interstitial'; }).length;
      this.currentStep = 0;
      this.currentQuestionNum = 0;
      this.answers = {};
      this.scores = {};
      this.agreeScaleValues = [];
      (config.scoreBuckets || []).forEach(function (b) { this.scores[b] = 0; }.bind(this));
      this.captureUTM();
      this.trackEvent('quiz_start', { question_count: this.questionCount });
      this.render();
    },

    trackEvent: function (eventName, data) {
      var payload = Object.assign({ quiz_name: this.quizName }, data || {});
      /* Meta Pixel */
      if (window.fbq) {
        try { window.fbq('trackCustom', eventName, payload); } catch (e) {}
      }
      /* GA4 / gtag */
      if (window.gtag) {
        try { window.gtag('event', eventName, payload); } catch (e) {}
      }
      /* dataLayer for GTM */
      if (window.dataLayer) {
        try { window.dataLayer.push(Object.assign({ event: eventName }, payload)); } catch (e) {}
      }
    },

    captureUTM: function () {
      var p = new URLSearchParams(window.location.search);
      this.utm = {
        source: p.get('utm_source') || '',
        medium: p.get('utm_medium') || '',
        campaign: p.get('utm_campaign') || '',
        content: p.get('utm_content') || '',
        term: p.get('utm_term') || ''
      };
    },

    buildUTMString: function () {
      var u = this.utm, parts = [];
      parts.push('utm_source=' + encodeURIComponent(u.source || 'quiz'));
      parts.push('utm_medium=' + encodeURIComponent(u.medium || 'organic'));
      parts.push('utm_campaign=' + encodeURIComponent(u.campaign || this.quizName));
      if (u.content) parts.push('utm_content=' + encodeURIComponent(u.content));
      if (u.term) parts.push('utm_term=' + encodeURIComponent(u.term));
      return parts.join('&');
    },

    render: function () {
      if (this.currentStep >= this.totalSteps) {
        this.showResult();
        return;
      }
      var q = this.questions[this.currentStep];
      if (q.type === 'interstitial') {
        this.renderInterstitial(q);
      } else if (q.type === 'agree') {
        this.renderAgreeScale(q);
      } else {
        this.renderStandard(q);
      }
    },

    buildProgressBar: function () {
      var pct = this.questionCount > 0
        ? Math.round((this.currentQuestionNum / this.questionCount) * 100)
        : 0;
      return '<div class="quiz-progress"><div class="quiz-progress-bar" style="width:' + pct + '%"></div></div>';
    },

    buildStepMeta: function (q) {
      var h = '';
      if (q.stage) {
        h += '<p class="quiz-stage-label">' + q.stage + '</p>';
      }
      var qNum = this.currentQuestionNum + 1;
      h += '<p class="quiz-step-label">Question ' + qNum + ' of ' + this.questionCount + '</p>';
      return h;
    },

    renderStandard: function (q) {
      var self = this;
      var h = this.buildProgressBar() + this.buildStepMeta(q);
      h += '<h2 class="quiz-question">' + q.question + '</h2><div class="quiz-options">';
      q.options.forEach(function (opt, i) {
        h += '<button class="quiz-option" data-index="' + i + '">' + opt.label + '</button>';
      });
      h += '</div>';
      this.container.innerHTML = h;
      this.container.classList.remove('quiz-result-view');
      requestAnimationFrame(function () {
        self.container.querySelectorAll('.quiz-option').forEach(function (el, idx) {
          el.style.animationDelay = (idx * 0.06) + 's';
          el.classList.add('quiz-option-enter');
        });
      });
      this.container.querySelectorAll('.quiz-option').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.selectAnswer(parseInt(btn.getAttribute('data-index')));
        });
      });
    },

    renderAgreeScale: function (q) {
      var self = this;
      var h = this.buildProgressBar() + this.buildStepMeta(q);
      h += '<h2 class="quiz-question quiz-statement">' + q.statement + '</h2>';
      h += '<div class="quiz-agree-scale">';
      var labels = ['SD', 'D', 'N', 'A', 'SA'];
      var titles = ['Strongly Disagree', 'Disagree', 'Neutral', 'Agree', 'Strongly Agree'];
      for (var i = 0; i < 5; i++) {
        h += '<button class="quiz-agree-btn" data-index="' + i + '" title="' + titles[i] + '">' +
          '<span class="quiz-agree-dot"></span>' +
          '<span class="quiz-agree-label">' + labels[i] + '</span>' +
          '</button>';
      }
      h += '</div>';
      h += '<div class="quiz-agree-axis"><span>Strongly Disagree</span><span>Strongly Agree</span></div>';
      this.container.innerHTML = h;
      this.container.classList.remove('quiz-result-view');
      this.container.querySelectorAll('.quiz-agree-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var idx = parseInt(btn.getAttribute('data-index'));
          self.selectAgreeAnswer(idx, idx + 1, q);
        });
      });
    },

    renderInterstitial: function (q) {
      var self = this;
      var h = this.buildProgressBar();
      h += '<div class="quiz-interstitial">';
      if (q.stat) {
        h += '<div class="quiz-interstitial-stat">' + q.stat + '</div>';
        if (q.statLabel) {
          h += '<div class="quiz-interstitial-stat-label">' + q.statLabel + '</div>';
        }
      }
      if (q.title) {
        h += '<h2 class="quiz-interstitial-title">' + q.title + '</h2>';
      }
      h += '<p class="quiz-interstitial-body">' + q.body + '</p>';
      h += '<button class="quiz-interstitial-btn">Continue</button>';
      h += '</div>';
      this.container.innerHTML = h;
      this.container.classList.remove('quiz-result-view');
      this.trackEvent('quiz_interstitial', {
        stat: q.stat || '',
        stat_label: q.statLabel || ''
      });
      this.container.querySelector('.quiz-interstitial-btn').addEventListener('click', function () {
        self.currentStep++;
        self.render();
      });
    },

    selectAnswer: function (idx) {
      var self = this;
      var q = this.questions[this.currentStep];
      var opt = q.options[idx];
      this.answers[this.currentStep] = opt;
      if (opt.scores) {
        Object.keys(opt.scores).forEach(function (k) {
          self.scores[k] = (self.scores[k] || 0) + opt.scores[k];
        });
      }
      this.container.querySelectorAll('.quiz-option')[idx].classList.add('quiz-option-selected');
      this.currentQuestionNum++;
      var q = this.questions[this.currentStep];
      this.trackEvent('quiz_answer', {
        question_num: this.currentQuestionNum,
        stage: q.stage || '',
        question: q.question || '',
        answer: opt.label,
        pct_complete: Math.round((this.currentQuestionNum / this.questionCount) * 100)
      });
      setTimeout(function () { self.currentStep++; self.render(); }, 300);
    },

    selectAgreeAnswer: function (idx, value, q) {
      var self = this;
      if (q.scores) {
        Object.keys(q.scores).forEach(function (k) {
          var arr = q.scores[k];
          if (Array.isArray(arr) && arr[idx] !== undefined) {
            self.scores[k] = (self.scores[k] || 0) + arr[idx];
          }
        });
      }
      this.agreeScaleValues.push(value);
      this.answers[this.currentStep] = { idx: idx, value: value };
      var btns = this.container.querySelectorAll('.quiz-agree-btn');
      btns[idx].classList.add('quiz-agree-selected');
      this.currentQuestionNum++;
      var titles = ['Strongly Disagree', 'Disagree', 'Neutral', 'Agree', 'Strongly Agree'];
      this.trackEvent('quiz_answer', {
        question_num: this.currentQuestionNum,
        stage: q.stage || '',
        statement: q.statement || '',
        answer: titles[idx],
        agree_value: value,
        pct_complete: Math.round((this.currentQuestionNum / this.questionCount) * 100)
      });
      setTimeout(function () { self.currentStep++; self.render(); }, 350);
    },

    getResult: function () {
      var max = -1, winner = '';
      var self = this;
      Object.keys(this.scores).forEach(function (k) {
        if (self.scores[k] > max) { max = self.scores[k]; winner = k; }
      });
      for (var i = 0; i < this.results.length; i++) {
        if (this.results[i].bucket === winner) return this.results[i];
      }
      return this.results[0];
    },

    getDesireProfileScore: function () {
      if (!this.agreeScaleValues.length) return 0;
      var sum = this.agreeScaleValues.reduce(function (a, b) { return a + b; }, 0);
      var min = this.agreeScaleValues.length;
      var max = this.agreeScaleValues.length * 5;
      return Math.round(((sum - min) / (max - min)) * 100);
    },

    getDesireProfileType: function () {
      var pt141Score = this.scores['pt141'] || 0;
      var emberScore = this.scores['ember'] || 0;
      var total = pt141Score + emberScore;
      if (total === 0) return 'Combined';
      var physRatio = pt141Score / total;
      if (this.agreeScaleValues.length >= 8) {
        var physicalIdx = [1, 4];
        var physicalSum = 0;
        var emotionalIdx = [0, 2];
        var emotionalSum = 0;
        physicalIdx.forEach(function (i) { if (i < this.agreeScaleValues.length) physicalSum += this.agreeScaleValues[i]; }.bind(this));
        emotionalIdx.forEach(function (i) { if (i < this.agreeScaleValues.length) emotionalSum += this.agreeScaleValues[i]; }.bind(this));
        var avgPhysical = physicalSum / physicalIdx.length;
        var avgEmotional = emotionalSum / emotionalIdx.length;
        if (avgPhysical >= 4 && avgEmotional >= 4) return 'Combined';
        if (avgPhysical >= 4) return 'Physical Response';
        if (avgEmotional >= 4) {
          if (physRatio < 0.4) return 'Stress-Related';
          return 'Hormonal Shift';
        }
      }
      if (physRatio > 0.6) return 'Physical Response';
      if (physRatio < 0.35) return 'Stress-Related';
      return 'Hormonal Shift';
    },

    getSeverity: function (score) {
      if (score <= 30) return { label: 'Mild', color: '#22c55e' };
      if (score <= 50) return { label: 'Moderate', color: '#eab308' };
      if (score <= 70) return { label: 'Significant', color: '#f97316' };
      return { label: 'Severe', color: '#ef4444' };
    },

    getKeyFindings: function (r) {
      var findings = [];
      var score = this.getDesireProfileScore();
      var profileType = this.getDesireProfileType();
      if (score >= 60) {
        findings.push('Your desire changes are significant and likely affecting your daily wellbeing and relationships.');
      } else if (score >= 30) {
        findings.push('You\u2019re experiencing a moderate shift in desire that\u2019s noticeably impacting your life.');
      } else {
        findings.push('You\u2019re noticing early changes worth addressing before they deepen.');
      }
      if (profileType === 'Physical Response' || profileType === 'Combined') {
        findings.push('Physical arousal and body response are central factors in your profile.');
      }
      if (profileType === 'Hormonal Shift' || profileType === 'Combined') {
        findings.push('Hormonal changes are likely contributing to what you\u2019re experiencing.');
      }
      if (profileType === 'Stress-Related') {
        findings.push('Lifestyle and emotional factors appear to be primary contributors.');
      }
      if (r.bucket === 'pt141') {
        findings.push('A prescription-strength approach may deliver the results you\u2019ve been looking for.');
      } else {
        findings.push('A daily natural support regimen is a well-matched starting point for your profile.');
      }
      return findings.slice(0, 3);
    },

    showResult: function () {
      if (this.clinicalMode) {
        this.showClinicalResult();
      } else {
        this.showStandardResult();
      }
    },

    showStandardResult: function () {
      var r = this.getResult(), utm = this.buildUTMString();
      this.trackEvent('quiz_complete', { bucket: r.bucket });
      var url = r.ctaUrl + (r.ctaUrl.indexOf('?') > -1 ? '&' : '?') + utm;
      var bh = '';
      if (r.benefits && r.benefits.length) {
        bh = '<ul class="quiz-benefits">';
        r.benefits.forEach(function (b) { bh += '<li>' + b + '</li>'; });
        bh += '</ul>';
      }
      var ih = r.image ? '<div class="quiz-result-image"><img src="' + r.image + '" alt="' + r.title + '" loading="lazy"></div>' : '';
      this.container.innerHTML = '<div class="quiz-result"><div class="quiz-result-badge">Your Results</div>' +
        '<h2 class="quiz-result-title">' + r.title + '</h2><p class="quiz-result-desc">' + r.description + '</p>' +
        ih + bh + '<a href="' + url + '" class="quiz-cta">' + r.ctaText + '</a></div>';
      this.container.classList.add('quiz-result-view');
    },

    showClinicalResult: function () {
      var r = this.getResult();
      var utm = this.buildUTMString();
      var url = r.ctaUrl + (r.ctaUrl.indexOf('?') > -1 ? '&' : '?') + utm;
      var score = this.getDesireProfileScore();
      var profileType = this.getDesireProfileType();
      var severity = this.getSeverity(score);
      var findings = this.getKeyFindings(r);

      var findingsHtml = '<ul class="quiz-findings">';
      findings.forEach(function (f) { findingsHtml += '<li>' + f + '</li>'; });
      findingsHtml += '</ul>';

      var bh = '';
      if (r.benefits && r.benefits.length) {
        bh = '<ul class="quiz-benefits">';
        r.benefits.forEach(function (b) { bh += '<li>' + b + '</li>'; });
        bh += '</ul>';
      }

      var circumference = 339;
      var dashOffset = Math.round(circumference - (score / 100) * circumference);

      var html = '<div class="quiz-result quiz-clinical-result">' +
        '<div class="quiz-result-badge">Your Desire Profile</div>' +

        '<div class="quiz-score-ring-wrap">' +
        '<svg class="quiz-score-ring" viewBox="0 0 120 120" width="140" height="140" aria-hidden="true">' +
        '<circle cx="60" cy="60" r="54" fill="none" stroke="#e0e0e0" stroke-width="10"/>' +
        '<circle cx="60" cy="60" r="54" fill="none" stroke="' + severity.color + '" stroke-width="10" ' +
        'stroke-dasharray="' + circumference + '" stroke-dashoffset="' + dashOffset + '" ' +
        'stroke-linecap="round" transform="rotate(-90 60 60)"/>' +
        '</svg>' +
        '<div class="quiz-score-number" style="color:' + severity.color + '">' + score + '</div>' +
        '</div>' +

        '<div class="quiz-severity-label" style="color:' + severity.color + '">' + severity.label + ' Impact</div>' +
        '<div class="quiz-profile-type-badge">' + profileType + '</div>' +

        '<p class="quiz-result-desc">' + r.description + '</p>' +

        '<div class="quiz-findings-wrap">' +
        '<h3 class="quiz-findings-title">Key Findings</h3>' +
        findingsHtml +
        '</div>' +

        '<div class="quiz-rec-card">' +
        '<div class="quiz-rec-label">Recommended for You</div>' +
        '<h3 class="quiz-rec-title">' + r.title + '</h3>' +
        bh +
        '<a href="' + url + '" class="quiz-cta">' + r.ctaText + '</a>' +
        '</div>' +
        '</div>';

      this.container.innerHTML = html;
      this.container.classList.add('quiz-result-view');

      this.trackEvent('quiz_complete', {
        bucket: r.bucket,
        desire_score: score,
        severity: severity.label,
        profile_type: profileType
      });
      if (window.fbq) {
        try {
          window.fbq('track', 'ViewContent', {
            content_name: this.quizName + '_result',
            content_category: 'quiz',
            content_ids: [r.bucket],
            value: score
          });
        } catch (e) {}
      }
    }
  };
})();
